export const LIB_VERSION = '15.0.0'; // autogenerated 
//# sourceMappingURL=version.js.map